import { GenericService } from '../generic.service';
import { JourneyType } from '@/models';

export class JourneyTypesService extends GenericService<JourneyType> {
  endpoint = '/menicon/v1/journey-types';
}
